if(!customElements.get('section-toggler')) {

class ComponentSectionToggler extends HTMLElement {
  constructor() {
    super();
    this.initializeToggler();
  }

  initializeToggler() {
    const buttons = this.querySelectorAll('button[data-section-id]');
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        const targetSectionId = button.dataset.sectionId;
        this.hideAllSectionsAfterToggler();
        this.showSection(targetSectionId);
        this.updateActiveState(button);
      });
    });

    // trigger click on the active button on load
    const activeButton = this.querySelector('button.active');
    if (activeButton) {
      activeButton.click();
    }
  }

  hideAllSectionsAfterToggler() {
    const mainContent = document.querySelector('#main-content');
    if (!mainContent) return;
    
    const togglerSection = this.closest('section');
    if (!togglerSection) return;
    
    const sections = mainContent.querySelectorAll('section');
    sections.forEach(section => {
      if (togglerSection.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING) {
        section.style.display = 'none';
      }
    });
  }

  showSection(sectionId) {
    if (!sectionId) return;
    const targetElement = document.querySelector(`#${sectionId}`);
    if (targetElement) {
      const parentSection = targetElement.closest('section');
      if (parentSection) {
        parentSection.style.display = '';
      }
    }
  }

  updateActiveState(activeButton) {
    const allButtons = this.querySelectorAll('button[data-section-id]');
    allButtons.forEach(button => {
      button.classList.remove('active');
    });
    activeButton.classList.add('active');
  }
}

customElements.define('section-toggler', ComponentSectionToggler);
}